import { Card, CardHeader, Stack } from '@mui/material';
import { PhotoStudioIntroduction } from 'codegen/axios/photo/photo_studio';
import { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EditButton from 'src/components/atoms/edit-button';
import DeleteModal from 'src/components/molecules/delete-modal';
import DetailCard from 'src/components/molecules/detail-card';
import { introductionFetchOrganize } from 'src/functions/fetch-value-organize';
import useFetch from 'src/hooks/use-fetch';
import usePush from 'src/hooks/use-push';
import { defaultValues } from 'src/components/organisms/photo-studio/detail/introduction/form';

export const PhotoStudioIntroductionCard: FC = () => {
  /* 定数宣言 */
  const title = '店舗紹介情報';

  /* hook宣言 */
  const navigate = useNavigate();
  const push = usePush();
  const { id: photoStudioId } = useParams();
  const [listUpdate, setListUpdate] = useState(0);

  /* データ取得 */
  const { fetchedData: responseData } = useFetch<PhotoStudioIntroduction>({
    iniState: defaultValues,
    reqProp: {
      pathKey: 'introduction',
      queryParams: { photoStudioId },
    },
    observable: [listUpdate],
  });

  const handleIntroductionEditButtonOnClick = () => {
    responseData.photoStudioId === undefined
      ? navigate(`/photoStudioStaff/setting/photoStudio/${photoStudioId}/introduction/new`)
      : navigate(
          `/photoStudioStaff/setting/photoStudio/${photoStudioId}/introduction/${responseData.photoStudioIntroductionId}/edit`
        );
  };

  const onDelete = () => {
    new Promise((resolve) =>
      push(resolve, {
        reqProp: {
          pathKey: 'introduction',
          method: 'delete',
          pathParam: responseData.photoStudioIntroductionId,
        },
        aftProp: {
          resolve,
          nextPath: `/setting/photoStudio/${photoStudioId}`,
          showMessage: {
            state: { snackBar: { open: true, viewType: 'info', message: '削除しました' } },
          },
        },
      })
    ).then(() => {
      setListUpdate(listUpdate + 1);
    });
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="flex-end" mt={9}>
        {responseData.photoStudioIntroductionId !== undefined && (
          <DeleteModal
            sx={{
              bgcolor: 'background.paper',
              minWidth: 50,
              minHeight: 47,
              boxShadow: 1,
              borderRadius: 2,
              ml: 2,
            }}
            OnDelete={onDelete}
          />
        )}

        <EditButton handleEditOnClick={handleIntroductionEditButtonOnClick} />
      </Stack>

      <Card sx={{ mt: 5 }}>
        <CardHeader title={title} sx={{ mb: 3, mt: 1 }} />

        <DetailCard defaultValues={introductionFetchOrganize(responseData)} />
      </Card>
    </>
  );
};
